import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {
	ChangeDetectorRef,
	Component,
	Inject,
} from '@angular/core';
import { FormControl } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';
import { ReplaySubject, Subject } from "rxjs";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { Fragebogen } from "./fragebogen.model";

const PATH_FILE = 'app/protected/fragebogen/fragebogen.component.ts';
const OBJ_LNG_NAME = 'fragebogen';
const BACKEND_PATH_PREFIX = 'fragebogen';

@Component({
    selector: 'oase-fragebogen',
    templateUrl: './fragebogen.component.html',
    styleUrls: ['./fragebogen.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, RouterModule, FlexModule]

})
export class FragebogenComponent extends Tabelle<Fragebogen> {

	spList: Fragebogen[] = new Array<Fragebogen>();
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredFragebogenen: ReplaySubject<Fragebogen[]> = new ReplaySubject<Fragebogen[]>(1);
	public datum = null;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/fb",
				PATH_FILE: PATH_FILE,
				extraDataForAdding: { }
			}
		);
		this.displayedColumns = ['title','ablaufdatum','typ','status','aktion'];
		this.breadcrumbService.addFriendlyNameForRoute('/protected/fb/', "Fragebogen");

	}

	getApiParams() {
		return "seite";
	}


	canRestartFragebogen(currentFrageBogen: Fragebogen): boolean {
		const currentDate=new Date();
		currentDate.setHours(0,0,0,0); //um nur das Datum zu vergleichen, nicht die Uhrzeit
		if(currentFrageBogen.ablaufdatum>=currentDate && currentFrageBogen.status===2)
			return true;
		return false;
	}

	canViewFragebogen(currentFrageBogen: Fragebogen): boolean {
		const currentDate=new Date();
		currentDate.setHours(0,0,0,0); //um nur das Datum zu vergleichen, nicht die Uhrzeit
		if(currentFrageBogen.status!==0)
			return true;
		return false;
	}
}